import { KEY } from '../types';

// Information
export * from './information/actions';

// Visit Search
export * from './practices/actions';
export * from './providers/actions';
export * from './specialties/actions';

// Medical History
export * from './allergies/actions';
export * from './conditions/actions';
export * from './medications/actions';
export * from './vitals/actions';
export * from './healthDocuments/actions';

// Insurance
export * from './insurance/actions';

// Payment method
export * from './paymentMethod/actions';

// Pharmacies
export * from './pharmacies/actions';

// SpeedPass
export * from './speedPass/actions';

export const RESET_AMWELL_ACTIVITY = `${KEY}.RESET_AMWELL_ACTIVITY`;

export const resetAmwellActivity = () => ({
  type: RESET_AMWELL_ACTIVITY
});
